import CardsInParkingTable from 'src/features/cards/CardsInParkingTable';

const InParking = () => {
    return <CardsInParkingTable />;
};

export default InParking;
